import { api } from "./index";

export function getOrderProductVariants(shipInsureId) {
  return api.get(`/order/${shipInsureId}/product_variants`);
}

export function getProductBySlug(merchantId, productSlug) {
  return api.post("/shopify/product/slug", {
    merchant_id: merchantId,
    product_slug: productSlug,
  });
}

export function getExchangeCatalog(shipInsureId, params) {
  return api.get(`/order/${shipInsureId}/exchange_catalog`, { params });
}

export function getExchangeQuote(shipInsureId, items) {
  return api.post(`/order/${shipInsureId}/exchange_quote`, { items });
}
